<template>
  <div class="main-content">
    <div class="block">
      <el-carousel height="calc(100vh - 2.2rem)">
        <!--<el-carousel :autoplay='false' height="calc(100vh - 2.2rem);">-->
        <el-carousel-item v-for="(item,index) in swiperList" :key="index">
          <img class="el-carousel-img" :src="item.imgUrl" alt="">
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
  export default {
      name: "index",
      data(){
          return {
            swiperList:[]
          }
      },
      components: {

      },
      created(){
        this.$http.get(`/outer/image/listImages.do`, {
          functionCode:1
        }).then((res)=>{
          this.swiperList=res.data
        })
      }
    }
</script>

<style lang="less">
  .main-content {
    height: 100%;
    width: 100%;
      .el-carousel-img{
        height:100%;
        width:100%;
      }
      .el-carousel__indicators{
        left: 20%;
        bottom:4%;
      }
      .el-carousel__button{
        width:.14rem;
        height:.14rem;
        box-sizing: border-box;
        border:2px solid #fff;
        border-radius: 50%;
        background: rgba(0,0,0,0);
      }
      .is-active .el-carousel__button{
        background: #F53A37;
        border:2px solid #F53A37;
      }

      .el-carousel__arrow{
        height:.6rem;
        width:.6rem;
        background: rgba(0,0,0,0);
        border:2px solid #3786f5;
      }
      .el-carousel__arrow i{
        font-size:.36rem;

      }
      .el-carousel__arrow--left{
        left:2rem;
      }
      .el-carousel__arrow--right{
        right: 2rem;
      }
      .el-icon-arrow-right:before,.el-icon-arrow-left:before{
        color: #3786f5;
      }



      .el-carousel__container {
        height:100%;
        color: #475669;
        font-size: 14px;
        opacity: 0.75;
        margin: 0;
      }
      .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
      }

      .el-carousel__item:nth-child(2n+1) {
        background-color: #d3dce6;
      }
  }


</style>



// WEBPACK FOOTER //
// src/pages/index.vue